export const isValidUrl = (value: string): boolean => {
  const regExp = new RegExp(/^(https?|chrome):\/\/[^\s$.?#].[^\s]*$/);

  return regExp.test(value);
};

export const assertCharacterNotPresent = (
  value: string,
  characterAssertion: string,
): boolean => {
  return !value.includes(characterAssertion);
};
